// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1zgpH","title":"style__title___jFKeY","subtitle":"style__subtitle___3BuMR","inputWrapper":"style__inputWrapper___1Xydq","input":"style__input___3YgpZ","inputPassword":"style__inputPassword___Mhtq1","inputError":"style__inputError___3oBa7","error":"style__error___3Jz7O","button":"style__button___JmEeT","text":"style__text___1kEUv","textBold":"style__textBold___3U2E8"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/register/style.css
// module id = 1007
// module chunks = 0